const data = {
  data: {
    Respuesta: true,
    blnError: false,
    codError: 'ASD',
    msgError: 'No va, error'
  }
}


export default data
